import { PaymentConfig, PaymentConfigMap } from "@base/types";

const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  // Non-EUR entries
  GB: "gbp",
  AU: "aud",

  // Official Eurozone Members (20 countries)
  AT: "eur", // Austria
  BE: "eur", // Belgium
  HR: "eur", // Croatia (Joined 2023)
  CY: "eur", // Cyprus
  EE: "eur", // Estonia
  FI: "eur", // Finland
  FR: "eur", // France
  DE: "eur", // Germany
  GR: "eur", // Greece
  IE: "eur", // Ireland
  IT: "eur", // Italy
  LV: "eur", // Latvia
  LT: "eur", // Lithuania
  LU: "eur", // Luxembourg
  MT: "eur", // Malta
  NL: "eur", // Netherlands
  PT: "eur", // Portugal
  SK: "eur", // Slovakia
  SI: "eur", // Slovenia
  ES: "eur", // Spain
  TR: "try", // Turkey

  // Microstates (Official agreement with EU)
  AD: "eur", // Andorra
  MC: "eur", // Monaco
  SM: "eur", // San Marino
  VA: "eur", // Vatican City

  // Unilateral adoption (Commonly supported in e-shops)
  ME: "eur", // Montenegro
};

export function getPaymentConfig(
  countryCode: string,
  paymentConfigMap: PaymentConfigMap,
  defaultPaymentConfig: PaymentConfig,
  defaultCurrency: string
): PaymentConfig {
  try {
    const currency = (COUNTRY_CURRENCY_MAP[countryCode] ?? defaultCurrency).toLowerCase();
    const config: PaymentConfig | undefined = paymentConfigMap[currency];
    return config ? config : defaultPaymentConfig;
  } catch (error) {
    console.error("Failed to get payments config:", error);
    throw error;
  }
}
